<mat-toolbar>Add Take 5's</mat-toolbar>
<div class="Dialog-body">
  <form>
    <mat-form-field class="DBSS">
        <mat-select placeholder="{{'State'}}"   [(ngModel)]="inputValuestate" name="Site" [formControl]="state" required>            
          <mat-option *ngFor="let Site of siteCodesList" [value]="Site.Id">
            {{Site.SiteName}} </mat-option>
          </mat-select>  
          <mat-error *ngIf="state.invalid">{{getErrorMessage()}}</mat-error>
    </mat-form-field>
  
    <mat-form-field class="DBSS">
      <mat-select placeholder="Month" [(ngModel)]="inputValueMonth"  name="inputValueMonth" [value]="inputValueMonth">
        
        <mat-option [value]="1">{{"January" | translate | async}}</mat-option>
        <mat-option [value]="2">{{'February' | translate | async}}</mat-option>
        <mat-option [value]="3">{{'March' | translate | async}}</mat-option>
        <mat-option [value]="4">{{'April' | translate | async}}</mat-option>
        <mat-option [value]="5">{{'May' | translate | async}}</mat-option>
        <mat-option [value]="6">{{"June" | translate | async}}</mat-option>
        <mat-option [value]="7">{{'July' | translate | async}}</mat-option>
        <mat-option [value]="8">{{'August' | translate | async}}</mat-option>
        <mat-option [value]="9">{{'September' | translate | async}}</mat-option>
        <mat-option [value]="10">{{'October' | translate | async}}</mat-option>
        <mat-option [value]="11">{{'November' | translate | async}}</mat-option>
        <mat-option [value]="12">{{'December' | translate | async}}</mat-option>


      </mat-select>
    </mat-form-field>

      <mat-form-field class="DBSS">
        <mat-select placeholder="Year" [(ngModel)]="inputValueYear" name="inputValueYear_" [value]="inputValueYear">
        
          <mat-option [value]="2019">2019</mat-option>
          <mat-option [value]="2020">2020</mat-option>
          <mat-option [value]="2021">2021</mat-option>
          <mat-option [value]="2022">2022</mat-option>
          <mat-option [value]="2023">2023</mat-option>
          <mat-option [value]="2024">2024</mat-option>
          <mat-option [value]="2025">2025</mat-option>
          <mat-option [value]="2026">2026</mat-option>
          <mat-option [value]="2027">2027</mat-option>
          <mat-option [value]="2028">2028</mat-option>
          <mat-option [value]="2029">2029</mat-option>
          <mat-option [value]="2030">2030</mat-option>
  
  
        </mat-select>
      </mat-form-field> 
    
    
      
    
      <mat-form-field class="DBSS">
        <input matInput type="number" placeholder="Number" min="1"  [(ngModel)]="inputValuenumber" name="number_">   
      </mat-form-field>
    
     

      <div class="buttonbelow">
        <button mat-raised-button (click)="DialogClose()">{{'Cancel' | translate | async}}</button> 
        <button mat-raised-button (click)="addTake5();">{{'Submit' | translate | async}}</button> 
        

      </div>
  </form>

</div>
